Ext.define('SA.view.pvt.AutoRefreshingAttributeDropdown', {
    alias: 'widget.pvt-auto-refreshing-attribute-dropdown',
    extend: 'SA.view.ComboButton',

    emptyText: 'None',
    textTpl: '{name}, {year}',
    ui: 'underline',

    beforeRender() {
        this.callParent();

        this.refresh();

        this.mon(this.projectView, 'change:attribute', this.refresh, this);
        this.mon(this.projectView.getProject(), 'change:attribute', this.refreshItems, this);
    },

    buildItems() {
        return SA.data.AttributesCache.get(this.projectView.getSupportedProjectAttributes());
    },

    getItem() {
        var {attribute} = this.value || {};

        return this.items.find(item => item.attribute === attribute);
    },

    refresh() {
        var variable = SA.data.AttributesCache.get(this.projectView.getAttribute());

        this.setValue(variable || null);
    },

    selectHandler(attribute) {
        if (!attribute) {
            return;
        }

        if (this.projectView.addAttribute(attribute.attribute)) {
            this.projectView.save();

            SA.data.RecentAttributes.add(attribute);
        }
    }
});